import { generateAbsenceUrlBaseV2 } from "../../../utils/utils";
import type { ApiCallerT } from "./types";
import type { PolicyApiT, UpdatePolicyResponseT } from "../types/policy.types";
import type { UpdatePermissionPolicyRequestDtoT, UpdateVacationPolicyRequestDtoT } from 'shared/domain/dtos/policy.dto';

export const createPolicyApi = (apiCaller: ApiCallerT): PolicyApiT => ({
  update: async (
    dto: UpdatePermissionPolicyRequestDtoT | UpdateVacationPolicyRequestDtoT,
    colaboraInstanceId: string,
    policyId: string,
  ) => {
    const url = generateAbsenceUrlBaseV2(`policies/${policyId}`);

    const response = await apiCaller<UpdatePolicyResponseT>(
      url,
      "PUT",
      dto,
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
});
